import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { Helmet } from 'react-helmet';
import getDecodedToken from '../../common/auth/utils/getDecodedToken';
import SessionList from '../../common/components/SessionList';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';
import { pushToast } from '../../redux/actions';
import { cancelMovementSpecialistSession, cancelTathataFollowUpSession, getMemberSessions } from './redux/actions';
import { selectBookedSessions, selectCompletedSessions, selectNewSessions } from './redux/selectors';
import RequestedSessionModal from './RequestedSessionModal';
import MemberBookedSessionModal from './MemberBookedSessionModal';
import HistoryModal from './HistoryModal';
import { sendIntercomEvent } from '../../common/events';

class MemberSessionsPage extends Component {
  state = {
    bookedSessionModalVisible: false,
    historyModalVisible: false,
    modalActiveSession: null,
    requestedSessionModalVisible: false,
  };

  componentWillMount() {
    this.props.dispatch(getMemberSessions(getDecodedToken().sub));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.cancelSession.get('loading') && nextProps.cancelSession.get('loaded')) {
      this.props.dispatch(pushToast({ message: 'Follow-Up session cancelled successfully' }));
      this.setState({
        bookedSessionModalVisible: false,
        modalActiveSession: null,
        requestedSessionModalVisible: false,
      });
    }
  }

  toggleRequestedSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      requestedSessionModalVisible: !state.requestedSessionModalVisible,
    }));
  };

  toggleBookedSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      bookedSessionModalVisible: !state.bookedSessionModalVisible,
    }));
  };

  toggleHistoryModal = () => {
    this.setState(state => ({
      historyModalVisible: !state.historyModalVisible,
    }));
  };

  onSessionCancel = () => {
    const session = this.state.modalActiveSession;

    if (session.type === 'movement-specialist') {
      this.props.dispatch(cancelMovementSpecialistSession(getDecodedToken().sub, session.id)).then(() => {
        const eventName = session.accepted_session_date ? 'member_cancel' : 'member_unbooked_cancel';
        sendIntercomEvent(eventName, {
          ms: {
            id: session.movementSpecialist.id,
            name: session.movementSpecialist.name,
          },
          dates: session.requestedDates,
        });
      });
    } else {
      this.props.dispatch(cancelTathataFollowUpSession(getDecodedToken().sub, session.id));
    }
  };

  render() {
    const { loaded, cancelSession, newSessions, bookedSessions, completedSessions } = this.props;
    const {
      bookedSessionModalVisible,
      historyModalVisible,
      modalActiveSession,
      requestedSessionModalVisible,
    } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="container sessions">
        <Helmet>
          <title>Tathata Golf - Follow-ups</title>
        </Helmet>
        {requestedSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleRequestedSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <RequestedSessionModal
              onCancel={this.onSessionCancel}
              loading={cancelSession.get('loading')}
              session={modalActiveSession}
              toggleModal={this.toggleRequestedSessionModal}
            />
          </Modal>
        )}
        {bookedSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleBookedSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <MemberBookedSessionModal
              onCancel={this.onSessionCancel}
              loading={cancelSession.get('loading')}
              session={modalActiveSession}
              toggleModal={this.toggleBookedSessionModal}
            />
          </Modal>
        )}
        {historyModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleHistoryModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <HistoryModal sessions={completedSessions} toggleModal={this.toggleHistoryModal} />
          </Modal>
        )}
        <div className="ms-admin__nav">Follow-Ups</div>
        <div className="ms-admin__sessions">
          <SessionList
            context="user"
            headerTitle="Requests Sent"
            icon="Envelope"
            onItemView={this.toggleRequestedSessionModal}
            sessions={newSessions}
            type="new"
          />
          <SessionList
            context="user"
            headerTitle="Booked"
            icon="Calendar"
            onItemView={this.toggleBookedSessionModal}
            type="booked"
            sessions={bookedSessions}
          />
          <SessionList
            context="user"
            headerTitle="History"
            icon="CheckmarkCircle"
            onItemView={this.toggleBookedSessionModal}
            sessions={completedSessions}
            showHistoryModal={this.toggleHistoryModal}
            type="completed"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bookedSessions: selectBookedSessions(state),
  cancelSession: state.subscription.cancelSession,
  completedSessions: selectCompletedSessions(state),
  loaded: state.subscription.sessions.get('loaded'),
  newSessions: selectNewSessions(state),
});

export default connect(mapStateToProps)(MemberSessionsPage);



// WEBPACK FOOTER //
// ./src/subscription/sessions/MemberSessionsPage.js